import { MouseEvent, useMemo } from "react";
import { CPAttachment } from "../../../api/models/unified";
import { isImage } from "../../../helpers/attachmentsHelepr";
import AttachmentThumbnail from "../AttachmentThumbnail";
import Icon from "../../icon/Icon";
import { MAIN_IMAGE_ROOT } from "../../../app_config";
import { downloadURI } from "../../../helpers/fileHelper";
import EmptyPlaceholder from "../../empty/EmptyPlaceholder";

interface AttachmentsGalleryDetailViewProps {
  attachments: CPAttachment[];
  handleOpenPreview: (attachment: CPAttachment) => void;
}

interface GalleryDetailItemProps {
  attachment: CPAttachment;
  handleOpenPreview: () => void;
}

const AttachmentsGalleryDetailItem = ({
  attachment,
  handleOpenPreview,
}: GalleryDetailItemProps) => {
  const localIsImage = useMemo(() => isImage(attachment), [attachment]);

  const handleAttachmentOnClick = () => {
    if (localIsImage) {
      return handleOpenPreview();
    }

    window.open(`${MAIN_IMAGE_ROOT}${attachment.publicUrl}`, "_blank");
  };

  const handleDownloadClick = (e: MouseEvent) => {
    e.stopPropagation();
    downloadURI(`${MAIN_IMAGE_ROOT}${attachment.publicUrl}`, attachment.name);
  };

  return (
    <div className="bg-gray50 flex w-[220px] flex-col justify-center rounded-lg p-5">
      <div
        className="flex cursor-pointer justify-center"
        onClick={() => handleAttachmentOnClick()}
      >
        <AttachmentThumbnail
          attachment={attachment}
          isImage={localIsImage}
          size="large"
          fileMode="thumbnail"
        />
      </div>
      <div
        className="mt-2 overflow-hidden text-base overflow-ellipsis whitespace-nowrap"
        title={attachment.name}
      >
        {attachment.name}
      </div>
      <div className="mt-2 flex justify-center gap-5">
        <Icon name="eye" onClick={() => handleAttachmentOnClick()} />
        <Icon name="file-download" onClick={handleDownloadClick} />
      </div>
    </div>
  );
};

const AttachmentsGalleryDetailView = ({
  attachments,
  handleOpenPreview,
}: AttachmentsGalleryDetailViewProps) => {
  return attachments.length > 0 ? (
    <div className="grid grid-cols-4">
      {attachments.map((attachment) => (
        <AttachmentsGalleryDetailItem
          key={attachment.id}
          attachment={attachment}
          handleOpenPreview={() => handleOpenPreview(attachment)}
        />
      ))}
    </div>
  ) : (
    <EmptyPlaceholder />
  );
};

export default AttachmentsGalleryDetailView;
